// extracted by mini-css-extract-plugin
export default {"overlay":"ConsentModal_overlay__zwMKn","modal":"ConsentModal_modal__1AJGY","closeBtn":"ConsentModal_closeBtn__ftdtT","consentLine":"ConsentModal_consentLine__TugUN"};